import http from '@/biz/http.mjs'
import openWindow from '@/script/openWindow.mjs'
import runAsync from '@/script/runAsync.mjs'
import _useAi from '../useAi.mjs'

export const useAi = ({...options}) => {
    const _ai = _useAi(options)

    return {
        ..._ai,

        async run() {
            await _ai.run()
            const files = await this._uploadDraftFiles()

            const {
                llmId,
                pkid: promptTemplateId,
                promptTemplateCode,
                promptTemplateResponseMode,
                usageScenarioCode,
            } = this.template

            const steps = this.template.llmPromptTemplateItems.map(
                ({
                    itemCode,
                    itemName,
                    pkid,
                    systemMessageTemplate,
                    toolMessageTemplate,
                    userMessageTemplate,
                    ...e
                }) => ({
                    ...e,
                    stepCode: itemCode,
                    stepId: pkid,
                    stepName: itemName,
                    systemMessage: systemMessageTemplate,
                    userMessage: userMessageTemplate,
                })
            )

            const {pkid: prjId, prjName, prjNo, sVer} = this.project

            const bizMap = {
                files,
                prjId,
                prompt: this.draft.content,
                prjName,
                prjNo,
                sVer,
                ...this.bizData,
            }

            const {workflowInstanceId} = await runAsync(
                () => http.post(
                    '/ai/execute',

                    {
                        bizMap,
                        llmId,
                        steps,
                        usageScenarioCode,
                        workflowCode: promptTemplateCode,
                        workflowId: promptTemplateId,
                        workflowResponseMode: promptTemplateResponseMode,
                    },
                ),

                {action: '执行AI助手'}
            )

            openWindow('/WorkflowInstance', {workflowInstanceId}, '_SELF')
        }
    }
}
